import theme from "@/theme";
import { SxProps, Theme } from "@mui/material/styles";

type Styles = {
  backdrop: SxProps<Theme>;
  paper: SxProps<Theme>;
  inner: SxProps<Theme>;
  iconTextBlock: SxProps<Theme>;
  iconWrap: SxProps<Theme>;
  title: SxProps<Theme>;
  subtitle: SxProps<Theme>;
  buttonsRow: SxProps<Theme>;
  cancelBtn: SxProps<Theme>;
  deactivateBtn: SxProps<Theme>;
};

export const styles: Styles = {
  backdrop: {
    backdropFilter: "blur(4px)",
  },

  paper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 263,
    height: 198,
    borderRadius: "16px",
    bgcolor: "rgba(255,255,255,0.9)",
    p: "10px 0",
    boxShadow: "0px 32px 48px -8px rgba(0,0,0,0.10), 0px 0px 14px -4px rgba(0,0,0,0.05)",
    display: "flex",
    zIndex: 100,
  },

  inner: {
    width: 263,
    height: 178,
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    px: 0,
  },

  iconTextBlock: {
    width: 263,
    height: 116,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    px: 0,
  },

  iconWrap: {
    width: 36,
    height: 36,
    minWidth: 36,
    minHeight: 36,
    maxWidth: 36,
    maxHeight: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#ffe7e4",
    borderRadius: "50%",
    margin: "0 auto",
  },

  title: {
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "-0.02em",
    color: "#1A1D1F",
    px: "16px",
  },

  subtitle: {
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-0.015em",
    color: "#6F767E",
    px: "16px",
  },

  buttonsRow: {
    width: 263,
    height: 48,
    px: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  cancelBtn: {
    width: 120,
    height: 48,
    borderRadius: "12px",
    textTransform: "none",
    fontFamily: "Inter, sans-serif",
    fontWeight: 700,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-0.01em",
    px: "20px",
    bgcolor: "transparent",
    borderColor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainBlue,
    "&:hover": {
      borderColor: theme.palette.custom.mainBlue,
      bgcolor: "rgba(42,133,255,0.06)",
    },
  },

  deactivateBtn: {
    width: 120,
    height: 48,
    borderRadius: "12px",
    textTransform: "none",
    fontFamily: "Inter, sans-serif",
    fontWeight: 700,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-0.01em",
    px: "20px",
    color: theme.palette.custom.secondaryRed,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
};
